import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Button from '../../components/common/Button';
import { citiesApi, extractOne } from '../../api/facades';

const CityDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const numId = id ? parseInt(id, 10) : NaN;

  const { data: res, isLoading, isError } = useQuery({
    queryKey: ['cities', numId],
    queryFn: () => citiesApi.get(numId),
    enabled: !Number.isNaN(numId),
  });
  const city = extractOne(res);

  if (Number.isNaN(numId) || isError || (!isLoading && !city)) {
    return (
      <div className="bg-white dark:bg-slate-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
        <p className="text-slate-600 dark:text-slate-400">City not found.</p>
        <Button variant="secondary" className="mt-4" onClick={() => navigate('/dashboard/settings/cities')}>
          Back to list
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-slate-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-slate-700 dark:text-slate-200">
          {isLoading ? 'Loading…' : city?.name ?? 'City'}
        </h1>
        <Button variant="secondary" onClick={() => navigate('/dashboard/settings/cities')}>
          Back to list
        </Button>
      </div>
      {isLoading ? (
        <p className="text-slate-500">Loading…</p>
      ) : (
        <dl className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <dt className="text-xs font-semibold text-slate-500 uppercase tracking-wider">State</dt>
            <dd className="text-slate-700 dark:text-slate-200">
              {(city as any).state?.name ?? (city as any).state_name ?? '—'}
            </dd>
          </div>
        </dl>
      )}
    </div>
  );
};

export default CityDetailPage;
